import { api } from '../../api/api';

// initial state
const state = {
   message:null
};

// getters
const getters = {
};

// actions
const actions = {
   ERROR_MESSAGE_SET:(context, {message})=>{
      return new Promise((resolve, reject)=>{
         context.commit('ERROR_MESSAGE_SET', {message});
         resolve();
      });
   },
   ERROR_MESSAGE_CLEAR:(context)=>{
      context.commit('ERROR_MESSAGE_SET', {message:null});
   }
};

// mutations
const mutations = {
   ERROR_MESSAGE_SET:(state,{message})=>{
      state.message = message;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/error.js